export default {
  default: () => import("/home/runner/work/wdd/wdd/frontend/wdd/layouts/default.vue").then(m => m.default || m),
  registration: () => import("/home/runner/work/wdd/wdd/frontend/wdd/layouts/registration.vue").then(m => m.default || m),
  results: () => import("/home/runner/work/wdd/wdd/frontend/wdd/layouts/results.vue").then(m => m.default || m),
  video: () => import("/home/runner/work/wdd/wdd/frontend/wdd/layouts/video.vue").then(m => m.default || m)
}